import { ReactNode } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { LangSelect, useLang } from '../i18n/LangProvider'
import { t } from '../catalogo/i18n'
import ukeLogo from '../assets/escudo-uke.png'
import styles from './PageTopbar.module.css'

// Look & feel (2026-10-22): "la barra de arriba con los botones volver y el cambio de idioma es muy
// fea, se ve en todas las pantallas". Cada pantalla tenía su propia barra (una caja blanca con borde
// con solo «← Volver» e idioma en el detalle de equipo; otra distinta en ALERTA). Barra común con el
// mismo aspecto que la de inicio (`AppShell`): fondo de topbar, línea verde inferior, fija arriba,
// logo «UKE Gara» que lleva al inicio, «←» para volver y el idioma a la derecha.
export function PageTopbar({ onBack, children }: { onBack?: () => void; children?: ReactNode }) {
  const lang = useLang()
  const navigate = useNavigate()

  return (
    <header className={styles.topbar}>
      <button className={styles.back} onClick={onBack ?? (() => navigate('/'))}>
        <span aria-hidden className={styles.backIcon}>
          ←
        </span>
        <span className={styles.backLabel}>{t('volver', lang)}</span>
      </button>
      <Link className={styles.brand} to="/">
        <img className={styles.brandLogo} src={ukeLogo} alt="" />
        <span className={styles.brandName}>UKE Gara</span>
      </Link>
      <div className={styles.actions}>
        <LangSelect className={styles.lang} />
        {children}
      </div>
    </header>
  )
}
